import { Box, Typography } from '@pocketlaw/tetris';
export function Label(props) {
    const { children } = props;
    return (<Box mb="lg">
      <Typography $fontSize="medium" $fontWeight="semibold">
        {children}
      </Typography>
    </Box>);
}
